'use strict';

/**
 * Language Service
 * Manages application language state, persistence, and switching
 */
angular
  .module('services.language', [])
  .constant('AVAILABLE_LANGUAGES', [
    { id: 'en', label: 'English' },
    { id: 'fr', label: 'Français' },
  ])
  .service('languageService', [
    '$translate',
    '$window',
    '$rootScope',
    'AVAILABLE_LANGUAGES',
    function ($translate, $window, $rootScope, AVAILABLE_LANGUAGES) {
      var STORAGE_KEY = 'preferredLanguage';

      // Internal state: maintain current language ID to avoid race conditions
      // with angular-translate's async loading
      var currentLanguageId = null;

      /**
       * Get all available languages
       * @returns {Array} Array of language objects with id and label
       */
      this.getAvailableLanguages = function () {
        return AVAILABLE_LANGUAGES;
      };

      /**
       * Get current language object
       * @returns {Object} Current language object or first available language as fallback
       */
      this.getCurrentLanguage = function () {
        // Use internal state instead of querying $translate.use()
        // to avoid race condition during async loading
        var currentLang = AVAILABLE_LANGUAGES.find(function (lang) {
          return lang.id === currentLanguageId;
        });

        // Fallback to first language if current not found
        return currentLang || AVAILABLE_LANGUAGES[0];
      };

      /**
       * Set language and persist to localStorage
       * Reloads the page to apply language change throughout the application
       * @param {string} langId - Language ID ('en' or 'fr')
       */
      this.setLanguage = function (langId) {
        // Update internal state
        currentLanguageId = langId;

        // Persist to localStorage
        try {
          $window.localStorage.setItem(STORAGE_KEY, langId);
        } catch (e) {
          console.warn('[languageService] Could not save language preference:', e);
        }

        // Reload page to apply language change everywhere
        $window.location.reload();
      };

      /**
       * Initialize language from localStorage or browser settings
       * @returns {Object} Initial language object
       */
      this.initializeLanguage = function () {
        var storedLang = null;

        // Try to get from localStorage
        try {
          storedLang = $window.localStorage.getItem(STORAGE_KEY);
        } catch (e) {
          console.warn('[languageService] Could not access localStorage:', e);
        }

        // Get browser language
        var browserLang = ($window.navigator.language || $window.navigator.userLanguage || 'en').split('-')[0]; // 'en-US' -> 'en', 'fr-CA' -> 'fr'

        // Check if browser language is supported
        var isBrowserLangSupported = AVAILABLE_LANGUAGES.some(function (lang) {
          return lang.id === browserLang;
        });

        // Priority: stored > browser (if supported) > default 'en'
        var initialLang = storedLang || (isBrowserLangSupported ? browserLang : 'en');

        // Update internal state BEFORE calling $translate.use()
        currentLanguageId = initialLang;

        // Set initial language (async load happens in background)
        $translate.use(initialLang);

        // Return language object using getCurrentLanguage() which now uses internal state
        return this.getCurrentLanguage();
      };
    },
  ]);
